import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminBuildings_idCardExportPdf = z.any()
export type TagsGetAdminBuildings_idCardExportPdf = z.infer<typeof tagsGetAdminBuildings_idCardExportPdf>

export const paramsGetAdminBuildings_idCardExportPdf = z.object({ "id": z.string().uuid() })
export type ParamsGetAdminBuildings_idCardExportPdf = z.infer<typeof paramsGetAdminBuildings_idCardExportPdf>

export const responseGetAdminBuildings_idCardExportPdf = z.any()
export type ResponseGetAdminBuildings_idCardExportPdf = z.infer<typeof responseGetAdminBuildings_idCardExportPdf>

interface IGetAdminBuildings_idCardExportPdf extends BaseMethodType {
  tags: TagsGetAdminBuildings_idCardExportPdf,
  params: ParamsGetAdminBuildings_idCardExportPdf,
  response: ResponseGetAdminBuildings_idCardExportPdf
}
export const URL = '/admin/buildings/:id/card/export/pdf'
export const validation = {
  get: {
    tags: tagsGetAdminBuildings_idCardExportPdf,
    params: paramsGetAdminBuildings_idCardExportPdf,
    response: responseGetAdminBuildings_idCardExportPdf
  }
}
export interface AdminBuildings_idCardExportPdf extends BaseRouteType {
  get: IGetAdminBuildings_idCardExportPdf
}